import { Component, OnInit } from '@angular/core';
import { getLoggerFor } from "@tylertech/logging";
import { OpenIdService } from "../../services";

@Component({
    selector: 'tid-login-callback',
    standalone: false,
    template: '<p>Processing login response....</p>',
})
export class TidLoginCallbackComponent
    implements OnInit
{
    private readonly log = getLoggerFor("TidLoginCallbackComponent");

    constructor(
        private readonly $openIdService: OpenIdService,
    ) { }

    ngOnInit(): void
    {
        this.$openIdService.loginPopupCallBack()
            .then(
                () =>
                {
                    this.log.debug(`ngOnInit | $openIdService.loginPopupCallBack`);
                },
                (e) =>
                {
                    this.log.error(`ngOnInit | $openIdService.loginPopupCallBack | ERROR => ${JSON.stringify(e)}`);
                })
            .finally(() =>
            {
                this.log.debug(`ngOnInit | $openIdService.loginCallBack complete`);
            });
    }
}
